import { render, staticRenderFns } from "./examYearList.vue?vue&type=template&id=2a8d1b32&scoped=true&"
import script from "./examYearList.vue?vue&type=script&lang=js&"
export * from "./examYearList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d1b32",
  null
  
)

export default component.exports